window.khadi = window.khadi || {};

khadi.config = {
  bpSmall: false,
  mediaQuerySmall: "screen and (max-width: " + 769 + "px)",
};

khadi.initWhenVisible = function (options) {
  var threshold = options.threshold ? options.threshold : 0;

  var observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof options.callback === "function") {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: "0px 0px " + threshold + "px 0px" }
  );

  observer.observe(options.element);
};

khadi.config.bpSmall = matchMedia(khadi.config.mediaQuerySmall).matches;
matchMedia(khadi.config.mediaQuerySmall).addListener(function (mql) {
  if (mql.matches) {
    khadi.config.bpSmall = true;
    document.dispatchEvent(new CustomEvent("matchSmall"));
  } else {
    khadi.config.bpSmall = false;
    document.dispatchEvent(new CustomEvent("unmatchSmall"));
  }
});

function testimonialSlider() {
  let sliders = document.querySelectorAll(".custom-testimonial-carousel");

  if (!sliders) return;

  sliders.forEach((slider) => {
    let size = slider.dataset.blocksize;
    if (size > 3) {
      new Flickity(slider, {
        wrapAround: true,
        cellAlign: "left",
        cellSelector: ".testimonial-slide-item",
        prevNextButtons: false,
        pageDots: true,
      });
    }
  });
}

function trustIconSlider() {
  let sliders = document.querySelectorAll(".logo-list-slider");

  if (!sliders) return;

  let settings = {
    wrapAround: true,
    contain: true,
    cellAlign: "left",
    cellSelector: ".logo-list__item",
    prevNextButtons: true,
    pageDots: false,
    freeScroll: true,
  };

  sliders.forEach((slider) => {
    let size = slider.dataset.blocksize;
    let sliderinit = slider.querySelector(".logo-list");
    if (!khadi.config.bpSmall) {
      if (size > 7) {
        sliderinit.style.display = "block";
        new Flickity(sliderinit, settings);
      }
    }
  });
}

function sticky() {
  const addToCart = document.getElementById("gokwik-buy-now");

  if (!addToCart) return;

  const observer = new IntersectionObserver(handleIntersection, {
    threshold: 0.1,
  });

  if (khadi.config.bpSmall) {
    observer.observe(addToCart);
  }

  function handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        document.body.classList.remove("stuck-addToCart");
      } else {
        document.body.classList.add("stuck-addToCart");
      }
    });
  }
  document.addEventListener("scroll", handleIntersection);
}

function handleSearch() {
  let searchBox = document.getElementById(
    "header-search-sections--20758378807618__header"
  );
  if (!searchBox) return;
  document.addEventListener("search:complete", function () {
    let isOpen = searchBox.hasAttribute("open");
    isOpen
      ? searchBox.removeAttribute("open")
      : searchBox.setAttribute("open", "");
  });
}

function ingredients() {
  let sliders = document.querySelectorAll("multi-column.ingredients");
  if (!sliders) return;
  sliders.forEach(function (slider) {
    new Flickity(slider, {
      wrapAround: true,
      contain: true,
      cellAlign: "left",
      cellSelector: ".multi-column__item",
      prevNextButtons: true,
      pageDots: false,
      freeScroll: true,
    });
  });
}

function inifiniteScroll() {
  if (!document.body.classList.contains("template-collection")) return;

  var endlessScroll = new Ajaxinate({
    container: ".collection__main .product-list",
    pagination: "#collection-pagination",
    loadingText: "Loading...",
  });
}

function prevNextSlideshow() {
  let btns = document.querySelectorAll('slideshow-carousel .prev-next-button');

  if (!btns.length) return;

  btns.forEach(btn => {
    btn.addEventListener('click', function (e) {
      btn.classList.add('waiting');
      setTimeout(function () {
        btn.classList.remove('waiting');
      }, 800);
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  prevNextSlideshow();
  sticky();
  //handleSearch();
  testimonialSlider();
  trustIconSlider();
  ingredients();
  inifiniteScroll();
});
